import { jsx } from 'react/jsx-runtime';
import { BaseTileBody } from '@vp/swan';

const TemplateTileContent = ({ children }) => /* @__PURE__ */ jsx(BaseTileBody, { pt: "4", children });

export { TemplateTileContent };
